import { useState } from "react";
import {
  highlightBracketedText,
  highlightUnderscoreText,
} from "src/utils/utils";
import { ImageAndTextListFragmentFragment } from "src/generated/graphql";
import Partner_Image_bg from "../../../images/Frame_partner.png";
import DynamicMedia from "src/components/shared/DynamicMedia";

type AutomaticContentProps = {
  content: ImageAndTextListFragmentFragment;
};

const ImageAndTextList = ({ content }: AutomaticContentProps) => {
  const { imageAndTextListCollection } = content;

  const items = imageAndTextListCollection?.items || [];

  return (
    <div>
      {items.map((item, index) => (
        <div className="image-text-list-item" key={index}>
          <div className="content-wrapper">
            <div className="text-content">
              <h2
                dangerouslySetInnerHTML={{
                  __html: highlightBracketedText(item?.title || "", "bold"),
                }}
              />
              <div className="image-and-text-description">
                <div className="lottie-container">
                  {item?.backgroundImage && (
                    <DynamicMedia
                      src={item?.backgroundImage.url ?? ""}
                      alt={item?.backgroundImage.title ?? ""}
                      ariaLabel={item?.backgroundImage.title  ?? ""}
                      lottieProps={{
                        loop: true,
                        style: {
                          transform: "unset",
                        },
                      }}
                      lottieClassName="feature-lottie"
                    />
                  )}
                </div>
                <p
                  dangerouslySetInnerHTML={{
                    __html: highlightUnderscoreText(
                      item?.description?.json?.content[0]?.content[0]?.value ||
                        ""
                    ),
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ImageAndTextList;